// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Router from "next/router";
import * as FormHelper$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormHelper.mjs";
import * as Config$PorterinUtils from "../../../../../../../../node_modules/@porterin/utils/src/configs/Config.mjs";
import * as JsBindings$PorterinUtils from "../../../../../../../../node_modules/@porterin/utils/src/bindings/common/JsBindings.mjs";
import * as CommonHelper$PorterinFeature from "../../../../core/helpers/CommonHelper.mjs";
import * as SharedHelper$PorterinFeature from "../../../../core/helpers/SharedHelper.mjs";
import * as SubmitBtnCmp$PorterinFeature from "../../../../../ui/components/SubmitBtnCmp.mjs";
import * as CategoryTypes$PorterinFeature from "../../../../../containers/fare-estimate-v1/domain/types/CategoryTypes.mjs";
import * as FareEstimateForm$PorterinFeature from "./FareEstimateForm.mjs";
import * as FareEstimateHelper$PorterinFeature from "../../../../core/helpers/FareEstimateHelper.mjs";
import * as RequirementVMMapper$PorterinFeature from "../../view-model/RequirementVMMapper.mjs";
import * as FareEstimateEventHelper$PorterinFeature from "../../../../../containers/fare-estimate-v1/domain/helpers/FareEstimateEventHelper.mjs";
import * as FareEstimateSelectReqCmp$PorterinFeature from "../FareEstimateSelectReqCmp.mjs";
import * as AutocompleteDropdownStyles$PorterinFeature from "../../../../auto-complete/view/styles/AutocompleteDropdownStyles.mjs";
import * as FareEstimateReqDropdownCmp$PorterinFeature from "../FareEstimateReqDropdownCmp.mjs";
import * as VehicleFareEstimateInputCmp$PorterinFeature from "../VehicleFareEstimateInputCmp.mjs";
import * as FareEstimateResultFormHelper$PorterinFeature from "../../../../core/helpers/FareEstimateResultFormHelper.mjs";
import * as GoogleReactAutocompleteCmpMod$PorterinFeature from "../../../../auto-complete/view/components/GoogleReactAutocompleteCmpMod.mjs";
import * as VehicleFareEstimateFormModuleScss from "../../styles/VehicleFareEstimateForm.module.scss";
import * as VehicleFareEstimateInputModuleScss from "../../styles/VehicleFareEstimateInput.module.scss";

var default_form_styles = VehicleFareEstimateFormModuleScss;

var default_input_styles = VehicleFareEstimateInputModuleScss;

function VehicleFareEstimateFormFieldsCmp(Props) {
  var stylesOpt = Props.styles;
  var input_field_stylesOpt = Props.input_field_styles;
  var form = Props.form;
  var fare_estimate_vm = Props.fare_estimate_vm;
  var response = Props.response;
  var service_category = Props.service_category;
  var citySelectedContext = Props.citySelectedContext;
  var styles = stylesOpt !== undefined ? Caml_option.valFromOption(stylesOpt) : default_form_styles;
  var input_field_styles = input_field_stylesOpt !== undefined ? Caml_option.valFromOption(input_field_stylesOpt) : default_input_styles;
  var place_holders = fare_estimate_vm.place_holders;
  var labels = fare_estimate_vm.labels;
  var match = Router.useRouter();
  var locale = match.locale;
  var pickupAddressOnChange = function (addressValue, _postalAddress) {
    Curry._2(form.updatePickup_address, (function (input, value) {
            return {
                    pickup_address: value,
                    drop_address: input.drop_address,
                    name: input.name,
                    mobile: input.mobile,
                    requirement: input.requirement,
                    consent_for_callback: input.consent_for_callback
                  };
          }), addressValue);
  };
  var dropAddressOnChange = function (addressValue, _postalAddress) {
    Curry._2(form.updateDrop_address, (function (input, value) {
            return {
                    pickup_address: input.pickup_address,
                    drop_address: value,
                    name: input.name,
                    mobile: input.mobile,
                    requirement: input.requirement,
                    consent_for_callback: input.consent_for_callback
                  };
          }), addressValue);
  };
  var getFieldError = function (field, callback) {
    var match = Curry._1(form.dirty, undefined);
    if (response === undefined) {
      return CommonHelper$PorterinFeature.getError(field);
    }
    if (response.TAG === /* Ok */0) {
      return CommonHelper$PorterinFeature.getError(field);
    }
    var form_error = response._0;
    if (form_error.TAG === /* FareEstimateHashError */0 || match) {
      return CommonHelper$PorterinFeature.getError(field);
    } else {
      return Curry._1(callback, Belt_Option.getWithDefault(form_error._0.field_errors, FareEstimateForm$PorterinFeature.inital));
    }
  };
  var requirementDropdownHandler = function (requirement) {
    Curry._2(form.updateRequirement, (function (input, value) {
            return {
                    pickup_address: input.pickup_address,
                    drop_address: input.drop_address,
                    name: input.name,
                    mobile: input.mobile,
                    requirement: value,
                    consent_for_callback: input.consent_for_callback
                  };
          }), requirement);
  };
  var requirementRadioHandler = function ($$event) {
    var value = FareEstimateHelper$PorterinFeature.requirementfromString(FormHelper$Catalyst.TargetEventWrapper.value($$event));
    Curry._2(form.updateRequirement, (function (input, value) {
            return {
                    pickup_address: input.pickup_address,
                    drop_address: input.drop_address,
                    name: input.name,
                    mobile: input.mobile,
                    requirement: value,
                    consent_for_callback: input.consent_for_callback
                  };
          }), value);
  };
  var getFormErrorMessage = function (param) {
    var match = Curry._1(form.dirty, undefined);
    if (response === undefined) {
      return "";
    }
    if (response.TAG === /* Ok */0) {
      return "";
    }
    var form_error = response._0;
    if (form_error.TAG === /* FareEstimateHashError */0) {
      if (match) {
        return "";
      } else {
        return form_error._0;
      }
    } else if (match) {
      return "";
    } else {
      return Belt_Option.getWithDefault(form_error._0.form_error, "");
    }
  };
  return React.createElement("form", {
              className: styles["fare-estimate-form"],
              onSubmit: (function ($$event) {
                  $$event.preventDefault();
                  Curry._1(form.submit, undefined);
                })
            }, React.createElement(VehicleFareEstimateInputCmp$PorterinFeature.make, {
                  label: labels.pickup,
                  is_required: true,
                  children: JsBindings$PorterinUtils.isBrowser(undefined) ? React.createElement(GoogleReactAutocompleteCmpMod$PorterinFeature.make, {
                          id: "pickup-address-" + String(Math.random()) + "",
                          value: form.input.pickup_address.landmark,
                          api_key: Config$PorterinUtils.google_maps_api_key,
                          form_on_change: pickupAddressOnChange,
                          placeholder: place_holders.pickup,
                          wrapperStyle: AutocompleteDropdownStyles$PorterinFeature.wrapperStyle,
                          menuStyle: AutocompleteDropdownStyles$PorterinFeature.menuStyle,
                          inputClass: "" + styles["pickup-input"] + " " + (
                            form.submitting ? styles.disabled : ""
                          ) + "",
                          itemClass: styles["dropdown-item"]
                        }) : null,
                  error: FareEstimateResultFormHelper$PorterinFeature.getAddressFieldError(form.pickup_addressResult, (function (field_errors) {
                          return field_errors.pickup;
                        }), response, FareEstimateResultFormHelper$PorterinFeature.addressFieldError(Curry._1(form.dirty, undefined), /* Pickup */0, fare_estimate_vm.errors_msgs.pickup)),
                  styles: input_field_styles
                }), React.createElement("div", {
                  className: styles.divider
                }), React.createElement(VehicleFareEstimateInputCmp$PorterinFeature.make, {
                  label: labels.drop,
                  is_required: true,
                  children: JsBindings$PorterinUtils.isBrowser(undefined) ? React.createElement(GoogleReactAutocompleteCmpMod$PorterinFeature.make, {
                          id: "pickup-address-" + String(Math.random()) + "",
                          value: form.input.drop_address.landmark,
                          api_key: Config$PorterinUtils.google_maps_api_key,
                          form_on_change: dropAddressOnChange,
                          placeholder: place_holders.drop,
                          wrapperStyle: AutocompleteDropdownStyles$PorterinFeature.wrapperStyle,
                          menuStyle: AutocompleteDropdownStyles$PorterinFeature.menuStyle,
                          inputClass: "" + styles["drop-input"] + " " + (
                            form.submitting ? styles.disabled : ""
                          ) + "",
                          itemClass: styles["dropdown-item"]
                        }) : null,
                  error: FareEstimateResultFormHelper$PorterinFeature.getAddressFieldError(form.drop_addressResult, (function (field_errors) {
                          return field_errors.drop;
                        }), response, FareEstimateResultFormHelper$PorterinFeature.addressFieldError(Curry._1(form.dirty, undefined), /* Dropoff */1, fare_estimate_vm.errors_msgs.drop)),
                  styles: input_field_styles
                }), React.createElement("div", {
                  className: styles.divider
                }), React.createElement(VehicleFareEstimateInputCmp$PorterinFeature.make, {
                  label: labels.phone,
                  is_required: true,
                  children: React.createElement("input", {
                        className: styles["mobile-input"],
                        disabled: form.submitting,
                        placeholder: place_holders.phone,
                        type: "tel",
                        value: form.input.mobile,
                        onBlur: (function (param) {
                            Curry._1(form.blurMobile, undefined);
                          }),
                        onChange: (function ($$event) {
                            Curry._2(form.updateMobile, (function (input, value) {
                                    return {
                                            pickup_address: input.pickup_address,
                                            drop_address: input.drop_address,
                                            name: input.name,
                                            mobile: value,
                                            requirement: input.requirement,
                                            consent_for_callback: input.consent_for_callback
                                          };
                                  }), $$event.target.value);
                          })
                      }),
                  error: getFieldError(form.mobileResult, (function (field_errors) {
                          return field_errors.mobile;
                        })),
                  styles: input_field_styles
                }), React.createElement("div", {
                  className: styles.divider
                }), React.createElement(VehicleFareEstimateInputCmp$PorterinFeature.make, {
                  label: labels.name,
                  is_required: true,
                  children: React.createElement("input", {
                        className: styles["name-input"],
                        disabled: form.submitting,
                        placeholder: place_holders.name,
                        type: "text",
                        value: form.input.name,
                        onBlur: (function (param) {
                            Curry._1(form.blurName, undefined);
                          }),
                        onChange: (function ($$event) {
                            Curry._2(form.updateName, (function (input, value) {
                                    return {
                                            pickup_address: input.pickup_address,
                                            drop_address: input.drop_address,
                                            name: value,
                                            mobile: input.mobile,
                                            requirement: input.requirement,
                                            consent_for_callback: input.consent_for_callback
                                          };
                                  }), $$event.target.value);
                          })
                      }),
                  error: getFieldError(form.nameResult, (function (field_errors) {
                          return field_errors.name;
                        })),
                  styles: input_field_styles
                }), React.createElement("div", {
                  className: styles.divider
                }), React.createElement("div", {
                  className: styles["requirement-wrapper"]
                }, React.createElement("div", {
                      className: styles["requirement-dropdown-wrapper"]
                    }, React.createElement(VehicleFareEstimateInputCmp$PorterinFeature.make, {
                          label: labels.requirement,
                          is_required: true,
                          children: React.createElement(FareEstimateReqDropdownCmp$PorterinFeature.make, {
                                requirement_placeholder: place_holders.requirement,
                                disabled: form.submitting,
                                value: Belt_Option.mapWithDefault(form.input.requirement, "", (function (requirement) {
                                        return RequirementVMMapper$PorterinFeature.getRequirementLabel(requirement, fare_estimate_vm.requirement_labels);
                                      })),
                                requirementHandler: requirementDropdownHandler,
                                requirement_labels: fare_estimate_vm.requirement_labels,
                                icon: fare_estimate_vm.icons.requirement
                              }),
                          error: getFieldError(form.requirementResult, (function (field_errors) {
                                  return field_errors.requirement;
                                })),
                          styles: input_field_styles,
                          className: input_field_styles["requirement-container"]
                        })), React.createElement("div", {
                      className: styles["requirement-radio-wrapper"]
                    }, React.createElement(FareEstimateSelectReqCmp$PorterinFeature.make, {
                          requirement: form.input.requirement,
                          onChange: requirementRadioHandler,
                          disabled: form.submitting,
                          label: fare_estimate_vm.labels.requirement,
                          is_required: true,
                          error: getFieldError(form.requirementResult, (function (field_errors) {
                                  return field_errors.requirement;
                                })),
                          requirement_labels: fare_estimate_vm.requirement_labels
                        }))), React.createElement("div", {
                  className: styles["submit-button-wrapper"]
                }, React.createElement(SubmitBtnCmp$PorterinFeature.make, {
                      is_disabled: form.submitting,
                      className: styles["submit-container"],
                      icon_label: fare_estimate_vm.submit_icon_label,
                      category: citySelectedContext.category,
                      call_back: (function (param) {
                          SharedHelper$PorterinFeature.triggerAcceptAllCookies(locale);
                        }),
                      event_name: FareEstimateEventHelper$PorterinFeature.submitButtonGaEvent(citySelectedContext.category, CategoryTypes$PorterinFeature.getTypeFromStringV2(service_category))
                    }), React.createElement("div", {
                      className: styles["submit-button-error"]
                    }, getFormErrorMessage(undefined))), React.createElement("div", {
                  className: styles["checkbox-input"],
                  onClick: (function (param) {
                      Curry._2(form.updateConsent_for_callback, (function (input, param) {
                              return {
                                      pickup_address: input.pickup_address,
                                      drop_address: input.drop_address,
                                      name: input.name,
                                      mobile: input.mobile,
                                      requirement: input.requirement,
                                      consent_for_callback: !form.input.consent_for_callback
                                    };
                            }), form.input.consent_for_callback);
                    })
                }, React.createElement("input", {
                      checked: form.input.consent_for_callback,
                      name: "whatspp-consent",
                      type: "checkbox"
                    }), React.createElement("p", {
                      className: styles.text
                    }, fare_estimate_vm.consent_label)));
}

var make = VehicleFareEstimateFormFieldsCmp;

export {
  default_form_styles ,
  default_input_styles ,
  make ,
}
/* default_form_styles Not a pure module */
